import { render, staticRenderFns } from "./dialog-add-server.vue?vue&type=template&id=4595a9d1&scoped=true"
import script from "./dialog-add-server.vue?vue&type=script&lang=js"
export * from "./dialog-add-server.vue?vue&type=script&lang=js"
import style0 from "./dialog-add-server.vue?vue&type=style&index=0&id=4595a9d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595a9d1",
  null
  
)

export default component.exports